import { createSlice } from "@reduxjs/toolkit";
import {
  getCompareProductKey,
  isSameCompareProduct,
  MAX_COMPARE_PRODUCTS,
  normalizeCompareProduct,
  normalizeCompareProducts,
} from "@/utils/compareProducts";

const initialState = {
  products: [],
};

const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    addCompareProduct: (state, action) => {
      const product = normalizeCompareProduct(action.payload);
      if (!product || state.products.length >= MAX_COMPARE_PRODUCTS) return;

      const alreadySelected = state.products.some(
        (selected) => isSameCompareProduct(selected, product)
      );

      if (!alreadySelected) state.products.push(product);
    },
    removeCompareProduct: (state, action) => {
      const key =
        typeof action.payload === "string"
          ? action.payload
          : getCompareProductKey(action.payload);

      state.products = state.products.filter(
        (product) => getCompareProductKey(product) !== key
      );
    },
    replaceCompareProducts: (state, action) => {
      state.products = normalizeCompareProducts(action.payload);
    },
    clearCompareProducts: (state) => {
      state.products = [];
    },
  },
});

export const {
  addCompareProduct,
  removeCompareProduct,
  replaceCompareProducts,
  clearCompareProducts,
} = compareSlice.actions;

export const selectCompareProducts = (state) => state?.compare?.products || [];

export default compareSlice.reducer;
